import { OpenInNew } from '@mui/icons-material';
import { Button, Typography, Stack } from '@mui/material';
import { Worker, Viewer } from '@react-pdf-viewer/core';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';

const PdfPreview = ({ fileUrl }: { fileUrl: string }) => {
  return (
    <Stack width="100%" height="100%" sx={{ textAlign: 'center', position: 'relative', zIndex: 10000 }}>
      <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ marginTop: 10, marginBottom: 20}}>
        <Button variant="contained" color="info" startIcon={<OpenInNew />}>
          <Typography variant="body1" sx={{ textDecoration: 'none' }}>Ouvrir dans un nouvel onglet</Typography>
        </Button>
      </a>
      <div style={{ width: '100%', height: '100%' }}>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
          <Viewer fileUrl={fileUrl} />
        </Worker>
      </div>
    </Stack>
  )
}

export default PdfPreview;